const deps = [
  'ui.router',
  'ui.bootstrap',
  require('@ordergroove/brandy/src/app/shipments/shipments.service'),
  require('../select'),
  require('../add'),
  require('../edit')
];

const app = angular.module('msi.payments.modal', deps)
  .service('editPaymentModal', require('./edit-payment-modal'))
  .config(require('./states'));

module.exports = app.name;
